module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header": "项目列表"
    }
  }, [_c('b-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "productCode",
      "label": "产品："
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    attrs: {
      "filterable": "",
      "id": "productCode"
    },
    on: {
      "change": _vm.changeProduct
    },
    model: {
      value: (_vm.productCode),
      callback: function($$v) {
        _vm.productCode = $$v
      },
      expression: "productCode"
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('el-option', {
      key: product.code,
      attrs: {
        "label": product.name,
        "value": product.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label-for": "tags",
      "label": "标签："
    }
  }, [_c('el-select', {
    staticClass: "mb-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "id": "tags"
    },
    on: {
      "change": _vm.changeTag
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  }, _vm._l((_vm.allTags), function(tag) {
    return _c('el-option', {
      key: tag.code,
      attrs: {
        "label": tag.name,
        "value": tag.code
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "responsive": "sm",
      "items": _vm.items,
      "fields": _vm.fields,
      "current-page": _vm.currentPage
    },
    scopedSlots: _vm._u([{
      key: "cell(product_code)",
      fn: function(row) {
        return [_vm._v("\n      " + _vm._s(_vm.getProduct(row.item.product_code)) + "\n    ")]
      }
    }, {
      key: "cell(tags)",
      fn: function(row) {
        return _vm._l((row.item.tags), function(tag) {
          return _c('b-badge', {
            key: tag,
            attrs: {
              "variant": "secondary"
            }
          }, [_vm._v(_vm._s(tag))])
        })
      }
    }, {
      key: "cell(app_status)",
      fn: function(row) {
        return [_vm._v("\n      " + _vm._s(_vm.getType(row.item.app_status)) + "\n    ")]
      }
    }, {
      key: "cell(detail)",
      fn: function(row) {
        return [_c('b-link', {
          attrs: {
            "to": {
              name: 'project-update',
              params: {
                serviceCode: row.item.service_code,
                appCode: row.item.code
              },
              query: {
                productCode: row.item.product_code
              }
            }
          }
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm",
            "variant": "outline-warning"
          }
        }, [_c('span', {
          staticClass: "fa fa-edit"
        }, [_vm._v(" 配置管理")])])], 1), _c('b-link', {
          attrs: {
            "to": {
              name: 'project-data',
              params: {
                serviceCode: row.item.service_code,
                appCode: row.item.code
              },
              query: {
                productCode: row.item.product_code
              }
            }
          }
        }, [_c('b-button', {
          staticClass: "mr-2",
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          }
        }, [_c('span', {
          staticClass: "fa fa-cloud-download"
        }, [_vm._v(" 数据查询")])])], 1)]
      }
    }])
  }), _vm._v(" "), _c('nav', [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "prev-text": "<<",
      "next-text": ">>",
      "hide-goto-end-buttons": ""
    },
    on: {
      "change": _vm.changePage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0a0b0e3a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/project/Project.vue
// module id = URZF
// module chunks = 4